import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

export const selectRuleSchema = createSelector(selectUnderwriting, ({ ruleSchema }) => ruleSchema);
